import styled from 'styled-components'
import { Plus } from '@styled-icons/entypo/Plus'
import { Pencil } from '@styled-icons/evil/Pencil'
import { GrayLight, White } from '../../../constants/constants'
export const BoxContainer = styled.div`
  border-style: solid;
  border-width: thin;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  background: ${White};
`
export const Box = styled.div`
  display: flex;
`

export const TitleBox = styled.div`
  align-self: flex-start;
  font-weight: bold;
  margin-bottom: 5px;
`

export const ButtonBox = styled.div`
  align-self: flex-end;
  margin-left: auto;
`

export const BodyBox = styled.div`
  display: flex;
  margin-top: 10px;
  white-space: pre-line;
  text-align: justify;
  flex-direction: column;
`
export const AddButton = styled(Plus)`
  color: ${GrayLight};
  cursor: pointer;
  transition-duration: 0.4s;
  margin-left: auto;
  &:hover {
    color: black;
  }
`
export const PencilButton = styled(Pencil)`
  color: ${GrayLight};
  cursor: pointer;
  transition-duration: 0.4s;
  margin-left: auto;
  &:hover {
    color: black;
  }
`
